import { lazy } from "react";

const ClickToCall = lazy(() =>
  import("./components/ClickToCall" /* webpackChunkName: 'ClickToCall' */)
);

const ClickToCallFixed = lazy(() =>
  import(
    "./components/ClickToCallFixed" /* webpackChunkName: 'ClickToCallFixed' */
  )
);

const ClickToSR = lazy(() =>
  import("./components/ClickToSR" /* webpackChunkName: 'ClickToSR' */)
);

const SmartAppBanner = lazy(() =>
  import("./components/SmartAppBanner" /* webpackChunkName: 'SmartAppBanner' */)
);

const Chat = lazy(() =>
  import("./components/Chat/Chat" /* webpackChunkName: 'Chat' */)
);

const OfferCountdown = lazy(() =>
  import("./components/OfferCountdown" /* webpackChunkName: 'OfferCountdown' */)
);

const InternetSpeedCalculator = lazy(() =>
  import(
    "./components/InternetSpeedCalculator/InternetSpeedCalculator" /* webpackChunkName: 'InternetSpeedCalculator' */
  )
);

const Combo = lazy(() =>
  import("./pages/Combo/Combo" /* webpackChunkName: 'Combo' */)
);

const DeviceInstallmentsBanner = lazy(() =>
  import(
    "./components/DeviceInstallments/DeviceInstallmentsBanner" /* webpackChunkName: 'DeviceInstallmentsBanner' */
  )
);

const DeviceInstallmentsDrawer = lazy(() =>
  import(
    "./components/DeviceInstallments/DeviceInstallmentsDrawer" /* webpackChunkName: 'DeviceInstallmentsDrawer' */
  )
);

export default {
  ClickToCall,
  ClickToSR,
  ClickToCallFixed,
  Chat,
  SmartAppBanner,
  OfferCountdown,
  InternetSpeedCalculator,
  Combo,
  DeviceInstallmentsBanner,
  DeviceInstallmentsDrawer
};
